// extracted by mini-css-extract-plugin
export default {"whiteboardContainer":"PcQlaq_gdTCJz8NOPJzg","relative":"j7UXldBpC83wK31c_k8w"};